var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"instagram-feed"},_vm.$listeners),[_vm._l((_vm.media),function(ref,index){
var src = ref.src;
var alt = ref.alt;
return [(src)?_c('figure',{key:src,staticClass:"instagram-feed__media-wrapper"},[(src.includes('video'))?_c('video',{staticClass:"instagram-feed__media",attrs:{"src":src,"controls":""}}):_c('img',{staticClass:"instagram-feed__media",attrs:{"src":src,"alt":alt}})]):_c('div',{key:index,staticClass:"instagram-feed__placeholder"})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }